import { FormPersonaNatural } from "../../PersonaNatural/components/Form";
import { Convocatoria } from "../../../../models/ConvocatoriasModel/convocatoria.model";

interface IProps {
  convocatorias?: Convocatoria;
  alSalirDeUnCampo?: (participante: any) => void;
}

/**
 * El grupo conformado llena el mismo formulario que la persona natural.
 *
 * Eran dos archivos de 918 y 736 lineas con los mismos campos en el mismo
 * orden; solo se diferenciaban en que el grupo pide ademas el pais de
 * nacimiento y guarda con otra funcion. Las dos diferencias viven ahora en
 * el formulario comun, elegidas por el perfil.
 */
export const FormGrupoConformado = (props: IProps) => (
  <FormPersonaNatural {...props} perfil="grupo" />
);
